import React from 'react';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';

import { IPasswordVisibilityIconProps } from 'src/features/auth/domain/types';

export const PasswordVisibilityIcon: React.FC<IPasswordVisibilityIconProps> = ({
	handleToggle,
	visibility,
}) => {
	return (
		<InputAdornment position='end'>
			<IconButton
				aria-label='toggle password visibility'
				onClick={handleToggle}
				edge='end'
			>
				{visibility ? <VisibilityOff /> : <Visibility />}
			</IconButton>
		</InputAdornment>
	);
};
